// extracted by mini-css-extract-plugin
module.exports = {"section":"components-Section-section-30cacd5d","headline":"components-Section-headline-a0d6a20f"};